import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFormsiteFormKey } from '@rsos/utils/metaTags';
import { sanitizedPhoneNumber } from '@rsos/utils/phoneNumberUtils';

const FormSite = () => {
  const { currentPSAP } = useSelector(state => state.psaps);
  const {
    fcc_id,
    agency_name,
    contact_title,
    contact_phone,
    contact_email,
    population,
    agency_state,
  } = currentPSAP;
  const { profile } = useSelector(state => state.sinatra.user);
  const { first_name, last_name } = profile;

  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://fs16.formsite.com/include/form/embedManager.js?594234805',
    );
    script.setAttribute('id', 'form-site-form');
    script.addEventListener('load', () => {
      //NOTE EmbedManager defined dynamically when script is loaded, adding no-undef so will pass es lint
      // eslint-disable-next-line no-undef
      EmbedManager.embed({
        key: `https://fs16.formsite.com/res/showFormEmbed?EParam=${getFormsiteFormKey()}`,
        width: '100%',
        mobileResponsive: true,
        prePopulate: {
          id66: agency_name,
          id67: fcc_id,
          id64: first_name,
          id65: last_name,
          id68: contact_title,
          id71: sanitizedPhoneNumber(contact_phone),
          id72: contact_email,
          id91: agency_state,
          id3: population,
        },
      });
    });
    document.body.appendChild(script);
    return () => {
      const formSiteRef = document.getElementById('form-site-form');
      document.body.removeChild(formSiteRef);
    };
  });
  return (
    <div id="apply_form">
      {/* eslint-disable-next-line */}
      <a name="form594234805" id="formAnchor594234805"></a>
    </div>
  );
};

export default FormSite;
